// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","455":"e68dd828","857":"03f99ef3"}[chunkId] + ".chunk.js";
};